import type OverscrollBehaviorStyles from './types';

const overscrollBehaviorContain: OverscrollBehaviorStyles = {
    overscrollBehavior: 'contain',
};

export default overscrollBehaviorContain;
